var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartHealth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#2776C4;stroke-miterlimit:20;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 15.2,
    y1: 10.4,
    x2: 11.31,
    y2: 9.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13.25,
    y1: 13.64,
    x2: 9.36,
    y2: 12.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.04,18.83c0,0-1.3,1.3,0,2.6c0,1.3,1.3,5.19-1.3,5.19c-1.3,0-2.6,0-2.6,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.81,17.53c0,0-6.49-3.89-14.28,0c0,0-2.6,2.6-3.89-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.81,21.43c0,0-6.49-5.19-15.58,1.3c0,1.3,1.3,2.6,0,3.89c0,1.3,0,1.3,1.3,2.6c0,0,3.89,5.19-6.49,9.09"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 26.88,
    y1: 28.57,
    x2: 30.13,
    y2: 30.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.28,32.46c0,0-0.75,3.24,0.55,5.84c0,1.3,1.3,2.6,0,3.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.64,43.49c0,0,3.89-6.49,3.89-9.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.02,22.73c0,0,3.89,2.6-1.3,7.79c1.3,2.6,3.89,9.09-5.19,16.87c-1.3,1.3-3.89,2.6-7.79-1.3 S4.17,34.41,10.66,26.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.66,18.83c0,0-5.19,5.19-1.3,10.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.55,24.02c0,0-1.3-10.38,5.19-12.98c0,0,3.89-1.3,2.6-7.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.83,13.64c0,0-2.6-5.19-9.09-2.6c2.6-1.3,9.09,0,11.68-6.49"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartHealth);
export default __webpack_public_path__ + "static/media/heart-health.26ac819105a9636e2a815b2dca9b06e7.svg";
export { ForwardRef as ReactComponent };